import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import throttle from 'lodash/throttle';
import { getSellableProducts, getSellableProductById, setProductListEmpty, clearPosFilter } from 'actions/EntityActions';
import { showError, hideLoading } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import POSProductCard from './POSProductCard';
import CircularProgress from '@mui/material/CircularProgress';
import DialogHeader from 'screens/components/basic/DialogHeader';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import 'styles/sass/pos/POSProduct.scss';

const compName = 'POSProductListPage';

class POSProductListPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            activePage: 1,
            categoryId: null,
            openDialogAddProductDetails: false,
            isLoading: false,
        };
    }

    componentDidMount() {
        if (this.props.POSProductsScroll) {
            this.handleScrollThrottled = throttle(this.handleScroll, 500);
            window.addEventListener('scroll', this.handleScrollThrottled);
        }
    }

    componentDidUpdate = (prevProps) => {
        if (
            this.props.posOrderSaveSuccess &&
            prevProps.posOrderSaveSuccess !== this.props.posOrderSaveSuccess
        ) {
            this.setState({ isAddingProduct: false });
        }

        if (
            prevProps.productFilter !== this.props.productFilter &&
            this.props.productFilter
        ) {
            const filters = {
                productId: this.props.productFilter.productId,
                branchId: this.props.branchId
            };
            this.props.getProductbyId(filters);
            this.setState({ activePage: 1 });
        }

        if (
            prevProps.POSproductFiltered !== this.props.POSproductFiltered &&
            this.props.POSproductFiltered
        ) {
            this.props.addToOrder(this.props.POSproductFiltered);
            this.props.clearPosFilter();
            this.props.setProductListEmpty();
            this.setState({ activePage: 1 });
        }

        if (this.state.isLoading) {
            this.setState({ isLoading: false })
        }
        
        if (
            !this.arraysEqual(this.props.POSSubCategory, prevProps.POSSubCategory) ||
            !this.arraysEqual(this.props.POSWeightsList, prevProps.POSWeightsList) ||
            !this.arraysEqual(this.props.POSBrandsList, prevProps.POSBrandsList) ||
            this.props.POSBasicCategory !== prevProps.POSBasicCategory ||
            this.props.POSSortFilter !== prevProps.POSSortFilter
        ) {
            this.updateActivePage();
        }

        if (prevProps.searchText !== this.props.searchText && this.props.searchText === ""){
            console.log("trigger");
            this.setState({ activePage: 1}, () => this.nextPage = 2)
        }
    }

    componentWillUnmount() {
        if (this.props.POSProductsScroll) {
            window.removeEventListener('scroll', this.handleScrollThrottled);
        }
    }

    updateActivePage = () => {
        this.setState({ activePage: 1 }, () => {
            this.props.setProductListEmpty();
            this.search();
        });
    }

    arraysEqual = (a, b) => {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;

        const sortedA = [...a].sort();
        const sortedB = [...b].sort();

        for (let i = 0; i < sortedA.length; ++i) {
            if (sortedA[i] !== sortedB[i]) return false;
        }

        return true;
    }

    pageChange = (page) => {
        this.setState({ activePage: page }, this.search);
    }

    search = (searchText) => {
        const filters = {
            page: this.state.activePage || 1,
            itemsPerPage: this.props.posShowProductCount,
            searchText: searchText != undefined ? searchText : (this.props.searchText ? this.props.searchText : null),
            categoryId: this.props.POSCategory,
            baseCategoryId: this.props.POSBasicCategory,
            subCategoryId: this.props.POSSubCategory ? this.props.POSSubCategory : [],
            Weight: this.props.POSWeightsList ? this.props.POSWeightsList : [],
            Brand: this.props.POSBrandsList ? this.props.POSBrandsList : [],
            SortId: this.props.POSSortFilter ? this.props.POSSortFilter : 0,
            branchId: this.props.branchId,
            THC_MIN: this.props.THC_MIN ? this.props.THC_MIN : 0,
            THC_MAX: this.props.THC_MAX ? this.props.THC_MAX : 100,
            CBD_MIN: this.props.CBD_MIN ? this.props.CBD_MIN : 0,
            CBD_MAX: this.props.CBD_MAX ? this.props.CBD_MAX : 100,
            onSale: this.props.onSale || false,
            onSaleMemberOnly: this.props.onSaleMemberOnly || false,
        };

        this.props.getProducts(filters);

        this.setState({ ...this.state, isLoading: true })
        if (this.props.POSProductsScroll) {
            this.props.hideLoading(0);
        }
    }

    closeAddProductDialog = () => {
        this.setState({ openDialogAddProductDetails: false, dialogProduct: null });
    }

    onProductSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
            this.setState(
                {
                    activePage: 1
                }
                , this.search(e.target.value));
            this.props.setProductListEmpty();
        }
    }

    handleScroll = () => {
        const totalLength = this.props.sellableProductsAll ? this.props.sellableProductsAll.length : 0;
        const isMoreProduct = this.props.productsLength > this.props.posShowProductCount && totalLength !== this.props.productsLength && totalLength !== 0;
        const scrollPosition = window.innerHeight + window.pageYOffset;
        const contentHeight = document.documentElement.scrollHeight;
        const endlessScrollTrigger = 60;
        if (scrollPosition + endlessScrollTrigger > contentHeight && isMoreProduct && !this.state.isLoading) {
            this.pageChange(this.state.activePage + 1);
        }
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        const s = this.state;
        const { productsLength, posShowProductCount } = this.props;
        const { activePage } = this.state;
        const products = p.POSProductsScroll ? p.sellableProductsAll : p.products;
        const productsItems = (
            <div className="row-flex shop_product_container">
                {
                    products && products.length > 0 ? products.map((item, index) => {
                        return (
                            this.props.showImageInPOSPage ?
                                <POSProductCard openDetailLog={() => this.props.addToOrder(item)} item={item} key={item.id} />
                                :
                                <Button
                                    label={item.name}
                                    className="btn btn-grid sale_products_button"
                                    onTouchTap={() => this.props.addToOrder(item)}
                                    key={item.id} />
                        );
                    })
                        : (<div className="list-group-item"><h4 className="list-group-item-heading">{t('pos.productListPage.noProductFound')}</h4></div>)
                }
            </div>);

        return (
            <div className="payment-background-list">
                <DialogHeader text={t('pos.productListPage.products')} classicClass="posDialogClassic" classicClassFont="classicClassFont" />
                <div className="row">
                    <div className="sales_product">
                        {productsItems}
                        {
                            this.state.isLoading && this.props.POSProductsScroll ?
                                <div className="loading">
                                    <CircularProgress size={50} thickness={5} />
                                </div>
                                :
                                ""
                        }
                        {!this.props.POSProductsScroll &&
                            <Pagination
                                length={productsLength}
                                itemsPerPage={posShowProductCount}
                                activePage={activePage}
                                onPageChange={this.pageChange}
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        productCategories: state.entity.productCategories,
        products: state.entity.sellableProducts,
        productsLength: state.entity.sellableProductsLength,
        searchText: state.form[`POSProductsProductSearch`],
        posOrder: state.entity.posOrder,
        POSCategory: state.form.POSCategory,
        posOrderSaveSuccess: state.form.posOrderSaveSuccess,
        branchId: state.common.branchId,
        productFilter: state.entity.productFilter,
        POSproductFiltered: state.entity.POSproductFiltered,
        POSBasicCategory: state.form[`POSTypeCheckbox`],
        POSSubCategory: state.form[`POSSpeciesCheckbox`],
        POSWeightsList: state.form[`POSWeightCheckbox`],
        POSBrandsList: state.form[`POSBrandCheckbox`],
        POSSortFilter: state.form[`SortFilter`],
        THC_MIN: state.form[`THCSliderMIN`],
        THC_MAX: state.form[`THCSliderMAX`],
        CBD_MIN: state.form[`CBDSliderMIN`],
        CBD_MAX: state.form[`CBDSliderMAX`],
        onSale: state.form[`POSOnSale`],
        onSaleMemberOnly: state.form[`POSOnSaleMemberOnly`],
        showImageInPOSPage: state.common.applicationSettings.showImageInPOSPage,
        posShowProductCount: state.common.applicationSettings.posShowProductCount,
        sellableProductsAll: state.entity.sellableProductsAll,
        loading: (state.common.ajaxCallsInProgress > 0) || state.common.loading,
        POSProductsScroll: state.common.applicationSettings.pOSProductsScroll !== false ? true : false
    };
}

function mapDispatchToProps(dispatch) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getProducts: (filters) => dispatch(getSellableProducts(filters)),
        showError: (message) => dispatch(showError(message)),
        getProductbyId: (filter) => dispatch(getSellableProductById(filter)),
        setProductListEmpty: () => dispatch(setProductListEmpty()),
        clearPosFilter: () => dispatch(clearPosFilter()),
        hideLoading: () => dispatch(hideLoading())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductListPage))